import { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { TeamCreateModal } from "entitites/teams/ui";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

export const TeamPageHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchString, setSearchString] = useState(
    searchParams.get("text") || ""
  );
  const [open, setOpen] = useState(false);
  const { data: roles } = useGetMyRolesQuery();

  return (
    <Box borderRadius="4px 4px 0px 0px" bgcolor="background.paper">
      <Box p="15px" fontWeight={700} fontSize="20px">
        Команды
      </Box>
      <Box
        borderRadius="4px"
        p="15px"
        display="flex"
        gap={1.5}
        alignItems="center"
      >
        <TextField
          value={searchString}
          onChange={(e) => setSearchString(e.target.value)}
          fullWidth
          label="Поиск"
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              ev.preventDefault();
              setSearchParams((prev) => {
                const { text, ...rest } = Object.fromEntries(prev);

                return {
                  ...rest,
                  ...(searchString ? { text: searchString } : {}),
                };
              });
            }
          }}
          InputProps={{
            endAdornment: (
              <>
                {searchString && (
                  <IconButton
                    onClick={() => {
                      setSearchParams((prev) => {
                        const { text, ...rest } = Object.fromEntries(prev);
                        return {
                          ...rest,
                        };
                      });
                      setSearchString("");
                    }}
                    size="small"
                  >
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton
                  onClick={() =>
                    setSearchParams((prev) => {
                      const { text, ...rest } = Object.fromEntries(prev);

                      return {
                        ...rest,
                        ...(searchString ? { text: searchString } : {}),
                      };
                    })
                  }
                  size="small"
                >
                  <SearchIcon />
                </IconButton>
              </>
            ),
          }}
          size="small"
        />
        <TeamCreateModal open={open} handleClose={() => setOpen(false)} />
        {Boolean(roles?.includes("staffdesk-admin")) && (
          <Button
            disableElevation
            onClick={() => setOpen(true)}
            sx={{
              textTransform: "none",
              minWidth: 186,
              ml: "auto",
              fontWeight: 700,
              height: "40px",
            }}
            variant="contained"
            // size="small"
          >
            Добавить команду +
          </Button>
        )}
      </Box>
    </Box>
  );
};
